import { c as e, h as t, l as n, m as r, p as i, r as a } from "./store-DlwVEumz.js";
import { a as o, i as s, o as c, r as l, t as u } from "./useKbSearch-Bw9JFxFS.js";
import { a as d, o as f, s as p } from "./dist-BCa5HPz5.js";
import { t as m } from "./collectionIcon-4B-wWD3h.js";
import { t as h } from "./page-EHBkKDUC.js";
import g, { createContext as _, forwardRef as v, useCallback as y, useEffect as b, useLayoutEffect as x, useRef as S, useState as C } from "react";
import { Fragment as w, jsx as T, jsxs as E } from "react/jsx-runtime";
import { Box as D, Button as O, ButtonList as k, DropdownButton as A, EmptyState as j, FlexBox as M, Icon as N, IconButton as P, Tag as F, Text as I, Timestamp as L, Tooltip as R } from "@dixa/lib-shared-habla";
import z from "classnames";
import { useNavigate as ee, useParams as te } from "react-router-dom";
import { createPortal as ne } from "react-dom";
import { renderToString as B } from "react-dom/server";
// ../delivery-common/src/hooks/useArticleViewEvent.ts
function re() {
	let [e] = r();
	return ({ articleId: t, languageId: n, origin: r }) => {
		let i = (/* @__PURE__ */ new Date()).valueOf(), a = window.location.href;
		return e({ variables: {
			articleId: t,
			languageId: n,
			ctx: {
				origin: r,
				pageUrl: a,
				createdAt: i
			}
		} });
	};
}
var V = {
	loadingContent: "_loadingContent_5z77j_1",
	content: "_content_5z77j_5",
	notFound: "_notFound_5z77j_10"
}, ie = /* @__PURE__ */ f(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), ae = /* @__PURE__ */ f(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, T = s, E = n, D = d, O = i, k = h, A = m, j = r, M = o, N = a, P = f, F = !1;
		function I(e) {
			return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(e) || x(e) === l;
		}
		function L(e) {
			return x(e) === u;
		}
		function R(e) {
			return x(e) === c;
		}
		function z(e) {
			return x(e) === s;
		}
		function ee(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function te(e) {
			return x(e) === d;
		}
		function ne(e) {
			return x(e) === i;
		}
		function B(e) {
			return x(e) === h;
		}
		function re(e) {
			return x(e) === m;
		}
		function V(e) {
			return x(e) === r;
		}
		function ie(e) {
			return x(e) === o;
		}
		function ae(e) {
			return x(e) === a;
		}
		function H(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = T, e.Element = E, e.ForwardRef = D, e.Fragment = O, e.Lazy = k, e.Memo = A, e.Portal = j, e.Profiler = M, e.StrictMode = N, e.Suspense = P, e.isAsyncMode = I, e.isConcurrentMode = L, e.isContextConsumer = R, e.isContextProvider = z, e.isElement = ee, e.isForwardRef = te, e.isFragment = ne, e.isLazy = B, e.isMemo = re, e.isPortal = V, e.isProfiler = ie, e.isStrictMode = ae, e.isSuspense = H, e.isValidElementType = b, e.typeOf = x;
	})();
})), H = /* @__PURE__ */ f(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? ie() : ae();
})), oe = /* @__PURE__ */ f(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), U = /* @__PURE__ */ f(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), W = /* @__PURE__ */ f(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), se = /* @__PURE__ */ f(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = U(), i = {}, a = W();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), ce = /* @__PURE__ */ f(((e, t) => {
	var n = H(), r = oe(), i = U(), a = W(), o = se(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: E(),
			objectOf: w,
			oneOf: C,
			oneOfType: T,
			shape: O,
			exact: k
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					}
					if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (M(s) !== e) {
					var c = N(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = M(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = M(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = M(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = F(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return N(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function w(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = M(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function T(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + P(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function E() {
			function e(e, t, n, r, i) {
				return A(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function D(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function O(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = M(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return D(r, a, o, l, N(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function k(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = M(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return D(o, s, c, d, N(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function A(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(A);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!A(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !A(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function j(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function M(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : j(t, e) ? "symbol" : t;
		}
		function N(e) {
			if (e == null) return "" + e;
			var t = M(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function P(e) {
			var t = N(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function F(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), le = /* @__PURE__ */ f(((e, t) => {
	var n = U();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), G = /* @__PURE__ */ p((/* @__PURE__ */ f(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = H();
		t.exports = ce()(n.isElement, !0);
	} else t.exports = le()();
})))()), ue = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function K(e, t) {
	return e(t = { exports: {} }, t.exports), t.exports;
}
var de = K((function(e) {
	(function(t) {
		var n = function(e, t, r) {
			if (!c(t) || u(t) || d(t) || f(t) || s(t)) return t;
			var i, a = 0, o = 0;
			if (l(t)) for (i = [], o = t.length; a < o; a++) i.push(n(e, t[a], r));
			else for (var p in i = {}, t) Object.prototype.hasOwnProperty.call(t, p) && (i[e(p, r)] = n(e, t[p], r));
			return i;
		}, r = function(e) {
			return p(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, (function(e, t) {
				return t ? t.toUpperCase() : "";
			}))).substr(0, 1).toLowerCase() + e.substr(1);
		}, i = function(e) {
			var t = r(e);
			return t.substr(0, 1).toUpperCase() + t.substr(1);
		}, a = function(e, t) {
			return function(e, t) {
				var n = (t ||= {}).separator || "_", r = t.split || /(?=[A-Z])/;
				return e.split(r).join(n);
			}(e, t).toLowerCase();
		}, o = Object.prototype.toString, s = function(e) {
			return typeof e == "function";
		}, c = function(e) {
			return e === Object(e);
		}, l = function(e) {
			return o.call(e) == "[object Array]";
		}, u = function(e) {
			return o.call(e) == "[object Date]";
		}, d = function(e) {
			return o.call(e) == "[object RegExp]";
		}, f = function(e) {
			return o.call(e) == "[object Boolean]";
		}, p = function(e) {
			return (e -= 0) == e;
		}, m = function(e, t) {
			var n = t && "process" in t ? t.process : t;
			return typeof n == "function" ? function(t, r) {
				return n(t, e, r);
			} : e;
		}, h = {
			camelize: r,
			decamelize: a,
			pascalize: i,
			depascalize: a,
			camelizeKeys: function(e, t) {
				return n(m(r, t), e);
			},
			decamelizeKeys: function(e, t) {
				return n(m(a, t), e, t);
			},
			pascalizeKeys: function(e, t) {
				return n(m(i, t), e);
			},
			depascalizeKeys: function() {
				return this.decamelizeKeys.apply(this, arguments);
			}
		};
		e.exports ? e.exports = h : t.humps = h;
	})(ue);
})).decamelize, fe = function(e) {
	if (Array.isArray(e)) return e;
}, pe = function(e, t) {
	if (typeof Symbol < "u" && Symbol.iterator in Object(e)) {
		var n = [], r = !0, i = !1, a = void 0;
		try {
			for (var o, s = e[Symbol.iterator](); !(r = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); r = !0);
		} catch (e) {
			i = !0, a = e;
		} finally {
			try {
				r || s.return == null || s.return();
			} finally {
				if (i) throw a;
			}
		}
		return n;
	}
}, q = function(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}, me = function(e, t) {
	if (e) {
		if (typeof e == "string") return q(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? q(e, t) : void 0;
	}
}, he = function() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}, ge = function(e, t) {
	return fe(e) || pe(e, t) || me(e, t) || he();
}, _e = K((function(e) {
	function t() {
		return e.exports = t = Object.assign || function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, t.apply(this, arguments);
	}
	e.exports = t;
})), ve = function(e, t) {
	if (e == null) return {};
	var n, r, i = {}, a = Object.keys(e);
	for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
	return i;
}, ye = function(e, t) {
	if (e == null) return {};
	var n, r, i = ve(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}, be = _(null);
function xe(e) {
	var t = e.children, n = t === void 0 ? "" : t, r = ye(e, ["children"]);
	return typeof n != "string" && (n = B(n)), g.createElement("template", _e({}, r, { dangerouslySetInnerHTML: { __html: n } }));
}
function Se(e) {
	var t = e.root, n = e.children;
	return ne(n === void 0 ? null : n, t);
}
function Ce(e) {
	var t = v((function(t, n) {
		var r, i, a = t.mode, o = a === void 0 ? "open" : a, s = t.delegatesFocus, c = s !== void 0 && s, l = t.styleSheets, u = l === void 0 ? [] : l, d = t.ssr, f = d !== void 0 && d, p = t.children, m = ye(t, [
			"mode",
			"delegatesFocus",
			"styleSheets",
			"ssr",
			"children"
		]), h = (i = S((r = n) && r.current), b((function() {
			r && (r.current = i.current);
		}), [r]), i), _ = ge(C(null), 2), v = _[0], y = _[1], w = `node_${o}${c}`;
		return x((function() {
			if (h.current) try {
				if (typeof n == "function" && n(h.current), f) {
					var e = h.current.shadowRoot;
					y(e);
					return;
				}
				var t = h.current.attachShadow({
					mode: o,
					delegatesFocus: c
				});
				u.length > 0 && (t.adoptedStyleSheets = u), y(t);
			} catch (e) {
				(function(e) {
					var t = e.error, n = e.styleSheets, r = e.root;
					switch (t.name) {
						case "NotSupportedError":
							n.length > 0 && (r.adoptedStyleSheets = n);
							break;
						default: throw t;
					}
				})({
					error: e,
					styleSheets: u,
					root: v
				});
			}
		}), [
			n,
			h,
			u
		]), g.createElement(g.Fragment, null, g.createElement(e.tag, _e({
			key: w,
			ref: h
		}, m), (v || f) && g.createElement(be.Provider, { value: v }, f ? g.createElement(xe, {
			shadowroot: o,
			shadowrootmode: o
		}, e.render({
			root: v,
			ssr: f,
			children: p
		})) : g.createElement(Se, { root: v }, e.render({
			root: v,
			ssr: f,
			children: p
		})))));
	}));
	return t.propTypes = {
		mode: G.default.oneOf(["open", "closed"]),
		delegatesFocus: G.default.bool,
		styleSheets: G.default.arrayOf(G.default.instanceOf(globalThis.CSSStyleSheet)),
		ssr: G.default.bool,
		children: G.default.node
	}, t;
}
xe.propTypes = { children: G.default.oneOfType([G.default.string, G.default.node]) }, Se.propTypes = {
	root: G.default.object.isRequired,
	children: G.default.node
};
var J = /* @__PURE__ */ new Map();
function we() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "core", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(e) {
		return e.children;
	};
	return new Proxy(e, { get: function(e, r) {
		var i = de(r, { separator: "-" }), a = `${t}-${i}`;
		return J.has(a) || J.set(a, Ce({
			tag: i,
			render: n
		})), J.get(a);
	} });
}
var Te = we();
// ../article/src/utils.ts
function Ee({ cssVersion: e = "1.3.0", noREMs: t = !1 } = {}) {
	return `https://staticfiles.dixa.io/knowledge/css/article/${e === "1.0.0" || e === "1.1.0" ? "1.3.0" : e}/${t ? "article-no-rems.css" : "article.css"}`;
}
// ../article/src/customElements.ts
function De() {
	window.customElements.get("html-block") || window.customElements.define("html-block", Oe);
}
var Oe = class extends HTMLElement {
	static observedAttributes = ["use-article-styles", "src"];
	divElement;
	styleElement;
	constructor() {
		super();
		let e = this.attachShadow({ mode: "open" });
		this.divElement = document.createElement("div"), this.divElement.className = "article", this.divElement.style.paddingBottom = "unset", this.divElement.style.maxInlineSize = "unset", e.appendChild(this.divElement), this.styleElement = document.createElement("link"), this.styleElement.rel = "stylesheet", this.styleElement.type = "text/css", this.styleElement.href = Ee({ noREMs: !0 });
	}
	updateSrc(e) {
		try {
			let t = decodeURIComponent(e);
			this.divElement.innerHTML = t;
		} catch (e) {
			console.error("Error decoding src in HtmlBlock", e);
		}
	}
	updateStyle(e) {
		let t = this.shadowRoot;
		t && (e === "true" ? t.contains(this.styleElement) || t.appendChild(this.styleElement) : t.contains(this.styleElement) && t.removeChild(this.styleElement));
	}
	attributeChangedCallback(e, t, n) {
		e === "src" && this.updateSrc(n), e === "use-article-styles" && this.updateStyle(n);
	}
}, ke = 500;
function Ae({ articleId: e, articleCollectionId: t, html: n, className: r, onClickInterlink: i, withCSS: a = !0 }) {
	let o = S(null), s = (e) => {
		let n = e.target;
		if (Me(n)) {
			e.preventDefault();
			return;
		}
		let r = n.closest("[data-knowledge-article]")?.getAttribute("data-knowledge-article");
		r ? (e.preventDefault(), e.stopPropagation(), i && i({
			articleId: r,
			articleCollectionId: t
		})) : Ne(o.current, e);
	}, c = y((t) => {
		setTimeout(() => {
			let n = e.match("#");
			if (t === null || !n) return;
			let r = e.split("#")[1] || "", i = t.querySelector(`[id="${r}"]`) || t.querySelector(`[name="${r}"]`);
			i && i.scrollIntoView({ behavior: "smooth" });
		}, ke);
	}, [e]);
	return b(() => {
		De();
	}, []), /* @__PURE__ */ E(w, { children: [a && /* @__PURE__ */ T("link", {
		rel: "stylesheet",
		type: "text/css",
		href: Ee({ noREMs: !0 })
	}), /* @__PURE__ */ T("div", {
		ref: c,
		children: /* @__PURE__ */ T("div", {
			className: z("article-body", r, "article"),
			style: {
				padding: 0,
				marginBottom: 0
			},
			dangerouslySetInnerHTML: { __html: n },
			ref: o,
			onClick: s
		})
	})] });
}
function je(e) {
	return /* @__PURE__ */ T(Te.div, {
		className: z("article-container", e.outerClassName),
		style: e.outerStyle,
		children: /* @__PURE__ */ T(Ae, { ...e })
	});
}
function Me(e) {
	let t = e.closest("img.image-preview, img.image-inline");
	if (!t || e.closest("a")) return !1;
	let n = t.currentSrc || t.src;
	if (!n) return !1;
	let r = new URL(n);
	return r.searchParams.delete("width"), window.open(r.href, "_blank", "noopener"), !0;
}
function Ne(e, t) {
	let n = t.target.closest("a")?.getAttribute("href") ?? null;
	if (n) {
		if (t.preventDefault(), t.stopPropagation(), n.indexOf("#") !== 0) window.open(n, "_blank", "noopener noreferrer");
		else if (n === "#") e.scrollIntoView({ behavior: "smooth" });
		else {
			try {
				let t = n.slice(1), r = `[name="${t}"]`, i = `[id="${t}"]`, a = e.querySelector(r) || e.querySelector(i);
				if (a) {
					a.scrollIntoView({ behavior: "smooth" });
					return;
				}
			} catch {}
			try {
				let t = e.querySelector(n);
				if (t) {
					t.scrollIntoView({ behavior: "smooth" });
					return;
				}
			} catch {}
		}
	}
}
// ../../../node_modules/valtio/esm/vanilla/utils.mjs
function Pe(e) {
	let t = a({
		data: Array.from(new Set(e)),
		has(e) {
			return this.data.indexOf(e) !== -1;
		},
		add(e) {
			let t = !1;
			return typeof e == "object" && e && (t = this.data.indexOf(a(e)) !== -1), this.data.indexOf(e) === -1 && !t && this.data.push(e), this;
		},
		delete(e) {
			let t = this.data.indexOf(e);
			return t !== -1 && (this.data.splice(t, 1), !0);
		},
		clear() {
			this.data.splice(0);
		},
		get size() {
			return this.data.length;
		},
		forEach(e) {
			this.data.forEach((t) => {
				e(t, t, this);
			});
		},
		get [Symbol.toStringTag]() {
			return "Set";
		},
		toJSON() {
			return new Set(this.data);
		},
		[Symbol.iterator]() {
			return this.data[Symbol.iterator]();
		},
		values() {
			return this.data.values();
		},
		keys() {
			return this.data.values();
		},
		entries() {
			return new Set(this.data).entries();
		}
	});
	return Object.defineProperties(t, {
		data: { enumerable: !1 },
		size: { enumerable: !1 },
		toJSON: { enumerable: !1 }
	}), Object.seal(t), t;
}
// ../delivery-common/src/hooks/useArticleRatingEvent.ts
function Fe() {
	let [e] = i();
	return { articleRating: {
		sendPositiveEvent: y(({ articleId: t, languageId: r, origin: i }) => {
			let a = (/* @__PURE__ */ new Date()).valueOf(), o = {
				articleId: t,
				languageId: r,
				ctx: {
					origin: i,
					pageUrl: window.location.href,
					createdAt: a
				}
			};
			return e({ variables: {
				...o,
				rating: n.Positive
			} });
		}, [e]),
		sendNegativeEvent: y(({ articleId: t, languageId: r, origin: i }) => {
			let a = (/* @__PURE__ */ new Date()).valueOf(), o = {
				articleId: t,
				languageId: r,
				ctx: {
					origin: i,
					pageUrl: window.location.href,
					createdAt: a
				}
			};
			return e({ variables: {
				...o,
				rating: n.Negative
			} });
		}, [e])
	} };
}
var Y = {
	button: "_button_sgpuo_1",
	positive: "_positive_sgpuo_4",
	negative: "_negative_sgpuo_8"
}, Ie = Pe(), Le = (e) => {
	Ie.add(e);
};
function Re({ articleId: e, languageId: t, origin: n }) {
	let { articleRating: { sendNegativeEvent: r, sendPositiveEvent: i } } = Fe(), a = s(Ie), o = () => {
		i({
			articleId: e,
			languageId: t,
			origin: n
		}), Le(e);
	}, c = () => {
		r({
			articleId: e,
			languageId: t,
			origin: n
		}), Le(e);
	}, l = n.suggestions ? "3" : "1";
	return a.has(e) ? /* @__PURE__ */ T(M, {
		gap: "300",
		justifyContent: "center",
		alignItems: "center",
		margin: "400 0 0",
		children: /* @__PURE__ */ T(I.Paragraph, {
			variant: l,
			children: "Thank you for your feedback."
		})
	}) : /* @__PURE__ */ E(M, {
		gap: "300",
		justifyContent: "center",
		alignItems: "center",
		margin: "400 0 0",
		children: [/* @__PURE__ */ T(I.Paragraph, {
			variant: l,
			children: "Was this helpful?"
		}), /* @__PURE__ */ E(M, {
			gap: "200",
			children: [/* @__PURE__ */ T(P, {
				className: z(Y.button, Y.positive),
				type: "button",
				variant: "tertiary",
				onClick: o,
				icon: "thumbs-up"
			}), /* @__PURE__ */ T(P, {
				className: z(Y.button, Y.negative),
				type: "button",
				variant: "tertiary",
				onClick: c,
				icon: "thumbs-down"
			})]
		})]
	});
}
// ../../../node_modules/react-use/esm/useMountedState.js
function ze() {
	var e = S(!1), t = y(function() {
		return e.current;
	}, []);
	return b(function() {
		return e.current = !0, function() {
			e.current = !1;
		};
	}, []), t;
}
// ../../../node_modules/react-use/esm/useSetState.js
var Be = function(e) {
	e === void 0 && (e = {});
	var t = C(e), n = t[0], r = t[1];
	return [n, y(function(e) {
		r(function(t) {
			return Object.assign({}, t, e instanceof Function ? e(t) : e);
		});
	}, [])];
}, Ve = /* @__PURE__ */ f(((e, t) => {
	t.exports = function() {
		var e = document.getSelection();
		if (!e.rangeCount) return function() {};
		for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
		switch (t.tagName.toUpperCase()) {
			case "INPUT":
			case "TEXTAREA":
				t.blur();
				break;
			default: t = null;
		}
		return e.removeAllRanges(), function() {
			e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(t) {
				e.addRange(t);
			}), t && t.focus();
		};
	};
})), He = /* @__PURE__ */ p((/* @__PURE__ */ f(((e, t) => {
	var n = Ve(), r = {
		"text/plain": "Text",
		"text/html": "Url",
		default: "Text"
	}, i = "Copy to clipboard: #{key}, Enter";
	function a(e) {
		var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
		return e.replace(/#{\s*key\s*}/g, t);
	}
	function o(e, t) {
		var o, s, c, l, u, d, f = !1;
		t ||= {}, o = t.debug || !1;
		try {
			if (c = n(), l = document.createRange(), u = document.getSelection(), d = document.createElement("span"), d.textContent = e, d.ariaHidden = "true", d.style.all = "unset", d.style.position = "fixed", d.style.top = 0, d.style.clip = "rect(0, 0, 0, 0)", d.style.whiteSpace = "pre", d.style.webkitUserSelect = "text", d.style.MozUserSelect = "text", d.style.msUserSelect = "text", d.style.userSelect = "text", d.addEventListener("copy", function(n) {
				if (n.stopPropagation(), t.format) {
					if (n.preventDefault(), n.clipboardData === void 0) {
						o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
						var i = r[t.format] || r.default;
						window.clipboardData.setData(i, e);
					} else n.clipboardData.clearData(), n.clipboardData.setData(t.format, e);
				}
				t.onCopy && (n.preventDefault(), t.onCopy(n.clipboardData));
			}), document.body.appendChild(d), l.selectNodeContents(d), u.addRange(l), !document.execCommand("copy")) throw Error("copy command was unsuccessful");
			f = !0;
		} catch (n) {
			o && console.error("unable to copy using execCommand: ", n), o && console.warn("trying IE specific stuff");
			try {
				window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), f = !0;
			} catch (n) {
				o && console.error("unable to copy using clipboardData: ", n), o && console.error("falling back to prompt"), s = a("message" in t ? t.message : i), window.prompt(s, e);
			}
		} finally {
			u && (typeof u.removeRange == "function" ? u.removeRange(l) : u.removeAllRanges()), d && document.body.removeChild(d), c();
		}
		return f;
	}
	t.exports = o;
})))()), Ue = function() {
	var e = ze(), t = Be({
		value: void 0,
		error: void 0,
		noUserInteraction: !0
	}), n = t[0], r = t[1];
	return [n, y(function(t) {
		if (e()) {
			var n, i;
			try {
				if (typeof t != "string" && typeof t != "number") {
					var a = /* @__PURE__ */ Error("Cannot copy typeof " + typeof t + " to clipboard, must be a string");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				}
				if (t === "") {
					var a = /* @__PURE__ */ Error("Cannot copy empty string to clipboard.");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				}
				i = t.toString(), n = (0, He.default)(i), r({
					value: i,
					error: void 0,
					noUserInteraction: n
				});
			} catch (e) {
				r({
					value: i,
					error: e,
					noUserInteraction: n
				});
			}
		}
	}, [])];
}, We = 3e3;
function Ge(e) {
	let [t, n] = Ue(), [r, i] = C(!1);
	return b(() => {
		let n = null;
		return t.value && (i(!0), n = setTimeout(() => {
			i(!1);
		}, e ?? We)), () => {
			n && clearTimeout(n);
		};
	}, [t, e]), {
		clipboard: t,
		setClipboard: n,
		timedClipboardIndicator: r
	};
}
var X = {
	copyIcon: "_copyIcon_4vozc_1",
	openIcon: "_openIcon_4vozc_2",
	copied: "_copied_4vozc_6"
}, Ke = ({ articleId: t, languageId: n, availableAt: { helpCenters: r, internalKbs: i }, callback: a }) => /* @__PURE__ */ E(w, { children: [r.map(({ name: e, url: t }) => {
	let n = new URL(t).hostname;
	return /* @__PURE__ */ T(qe, {
		url: t,
		callback: a,
		name: e,
		hostname: n,
		icon: "question"
	}, t);
}), i.map(({ name: r, collectionId: i, iconColor: o }) => {
	let { path: s, search: c } = e.internalKBArticle({
		collectionId: i,
		articleId: t,
		languageId: n
	}), l = `${window.location.origin}${s}${c ? `?${c}` : ""}`;
	return /* @__PURE__ */ T(qe, {
		url: l,
		callback: a,
		name: r,
		hostname: "Internal Knowledge Base",
		icon: "file-text",
		iconColor: o
	}, l);
})] }), qe = ({ callback: e, hostname: t, icon: n, iconColor: r, name: i, url: a, faviconUrl: o }) => /* @__PURE__ */ T(k.Item, {
	onClick: () => e(a),
	buttonProps: { style: { cursor: "pointer" } },
	children: /* @__PURE__ */ E(M, {
		as: "span",
		flexDirection: "row",
		alignItems: "center",
		gap: "300",
		children: [o ? /* @__PURE__ */ T("img", {
			src: o,
			alt: `Favicon for ${i}`
		}) : r ? /* @__PURE__ */ T(m, { color: r }) : /* @__PURE__ */ T(M, {
			as: "span",
			padding: "200",
			background: "neutral.200",
			borderRadius: "100",
			children: /* @__PURE__ */ T(N, {
				name: n,
				size: 16
			})
		}), /* @__PURE__ */ E(M, {
			as: "span",
			flexDirection: "column",
			alignItems: "flex-start",
			children: [i, t && /* @__PURE__ */ T(I.Paragraph, {
				as: "span",
				variant: "4",
				subdued: !0,
				children: t
			})]
		})]
	})
}, a), Je = ({ availableAt: e, articleId: t, languageId: n, setCopiedUrl: r }) => /* @__PURE__ */ E(k, { children: [/* @__PURE__ */ T(k.Item, { children: /* @__PURE__ */ T(I.Paragraph, {
	as: "span",
	variant: "4",
	subdued: !0,
	children: "Copy link to article in..."
}) }), /* @__PURE__ */ T(Ke, {
	articleId: t,
	availableAt: e,
	languageId: n,
	callback: (e) => r(e)
})] }), Ye = ({ articleId: e, availableAt: t, languageId: n }) => /* @__PURE__ */ E(k, { children: [/* @__PURE__ */ T(k.Item, { children: /* @__PURE__ */ T(I.Paragraph, {
	as: "span",
	variant: "4",
	subdued: !0,
	children: "Open article in..."
}) }), /* @__PURE__ */ T(Ke, {
	availableAt: t,
	languageId: n,
	articleId: e,
	callback: (e) => window.open(e, "_blank")
})] }), Xe = ({ articleId: e, availableAt: t, buttonLabel: n, languageId: r, buttonVariant: i, showOpenOptions: a = !0 }) => {
	let { timedClipboardIndicator: o, setClipboard: s } = Ge(), { helpCenters: c } = t, l = o ? "check-circle-filled" : "link", u = z(X.copyIcon, { [X.copied]: o }), d = a && c.length > 0;
	return c.length === 0 ? /* @__PURE__ */ T(w, {}) : /* @__PURE__ */ E(M, {
		gap: "100",
		alignItems: "center",
		children: [/* @__PURE__ */ T(R, {
			content: o ? "Copied!" : c.length > 1 ? "Copy link..." : "Copy link",
			side: "top",
			children: /* @__PURE__ */ T(A, {
				noArrow: !n,
				onClick: (e) => {
					e.preventDefault(), e.stopPropagation();
				},
				buttonProps: {
					variant: i,
					style: { padding: "var(--dixa-size-spacer-200)" }
				},
				dropdown: /* @__PURE__ */ T(Je, {
					articleId: e,
					availableAt: t,
					setCopiedUrl: s,
					languageId: r
				}),
				show: !o && void 0,
				children: n ? /* @__PURE__ */ E(M, {
					gap: "200",
					children: [
						/* @__PURE__ */ T(N, {
							className: u,
							name: l
						}),
						" ",
						n
					]
				}) : /* @__PURE__ */ T(N, {
					className: u,
					name: l
				})
			})
		}), d ? /* @__PURE__ */ T(R, {
			content: c.length > 1 ? "Open..." : "Open",
			side: "top",
			children: /* @__PURE__ */ T(A, {
				noArrow: !0,
				onClick: (e) => {
					e.preventDefault(), e.stopPropagation();
				},
				buttonProps: {
					variant: i,
					style: { padding: "var(--dixa-size-spacer-200)" }
				},
				dropdown: /* @__PURE__ */ T(Ye, {
					articleId: e,
					availableAt: t,
					languageId: r
				}),
				children: /* @__PURE__ */ T(N, {
					name: "external-link",
					className: X.openIcon
				})
			})
		}) : null]
	});
}, Z = { externalLink: "_externalLink_9x9tw_1" }, Ze = ({ title: e, articleId: t, availableAt: n, collectionId: r, currentLanguageId: i }) => /* @__PURE__ */ T(h.Head, {
	className: Z.head,
	slotLeft: /* @__PURE__ */ T(h.HeadTitle, { title: e }),
	slotRight: /* @__PURE__ */ E(M, { children: [/* @__PURE__ */ T(Xe, {
		articleId: t,
		availableAt: n,
		buttonLabel: "Copy link",
		languageId: i,
		buttonVariant: "secondary",
		showOpenOptions: !1
	}), /* @__PURE__ */ T(Qe, {
		articleId: t,
		collectionId: r,
		currentLanguageId: i
	})] })
}), Qe = ({ articleId: t, collectionId: n, currentLanguageId: r }) => {
	let i = e.articleEdit({
		articleId: t,
		collectionId: n,
		languageId: r
	});
	return /* @__PURE__ */ T(D, {
		margin: "0 0 0 200",
		children: /* @__PURE__ */ T("a", {
			className: Z.externalLink,
			href: `${window.location.origin}${i}`,
			target: "_blank",
			rel: "noreferrer",
			children: /* @__PURE__ */ T(O, {
				icon: "pen",
				variant: "secondary",
				children: "Edit"
			})
		})
	});
}, Q = {
	metaContainer: "_metaContainer_1vo90_1",
	metaIcon: "_metaIcon_1vo90_23",
	metaTag: "_metaTag_1vo90_29"
}, $e = ({ article: e }) => /* @__PURE__ */ E("dl", {
	className: Q.metaContainer,
	children: [
		/* @__PURE__ */ E("dt", { children: [/* @__PURE__ */ T(N, {
			className: Q.metaIcon,
			name: "history"
		}), "Last Updated"] }),
		/* @__PURE__ */ E("dd", { children: [/* @__PURE__ */ T(L, {
			time: e.publishedAt / 1e3,
			refreshRate: 6e4
		}), e.publishedBy ? ` by ${e.publishedBy.name}` : ""] }),
		e.parentCategory && /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ E("dt", { children: [/* @__PURE__ */ T(N, {
			className: Q.metaIcon,
			name: "folder"
		}), "Category"] }), /* @__PURE__ */ T("dd", { children: e.parentCategory.title })] }),
		e.tags.length > 0 && /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ E("dt", { children: [/* @__PURE__ */ T(N, {
			className: Q.metaIcon,
			name: "tag"
		}), "Tags"] }), /* @__PURE__ */ T("dd", { children: e.tags.map((e) => /* @__PURE__ */ T(F, {
			color: e.color,
			className: Q.metaTag,
			children: e.name
		}, e.id)) })] })
	]
}), $ = {
	articleHeaderContainer: "_articleHeaderContainer_1uk74_1",
	loadingContent: "_loadingContent_1uk74_8",
	content: "_content_1uk74_12",
	articleContent: "_articleContent_1uk74_17",
	title: "_title_1uk74_23"
}, et = ({ collectionId: t, languageId: n, article: r }) => {
	let i = ee();
	return /* @__PURE__ */ E(M, {
		className: $.content,
		children: [/* @__PURE__ */ T(Ze, {
			currentLanguageId: n,
			title: r.title,
			articleId: r.id,
			availableAt: r.availableAt,
			collectionId: r.parentCategory?.id ?? void 0
		}), /* @__PURE__ */ E(D, {
			className: $.articleContent,
			"data-color-mode": "light",
			children: [
				/* @__PURE__ */ E(M, {
					flexDirection: "column",
					className: $.articleHeaderContainer,
					children: [/* @__PURE__ */ T(tt, { children: r.title }), /* @__PURE__ */ T($e, { article: r })]
				}),
				/* @__PURE__ */ T(je, {
					articleId: r.id,
					articleCollectionId: t,
					html: r.content.html,
					cssVersion: r.content.cssVersion,
					onClickInterlink: ({ articleId: t, articleCollectionId: r }) => {
						let { path: a, search: o } = e.internalKBArticle({
							articleId: t,
							collectionId: r,
							languageId: n
						});
						i({
							pathname: a,
							search: [window.location.search, o].filter(Boolean).join("&")
						});
					}
				}),
				/* @__PURE__ */ T(Re, {
					articleId: r.id,
					languageId: n,
					origin: { internalKb: { id: t } }
				})
			]
		})]
	});
}, tt = ({ children: e }) => /* @__PURE__ */ T("h1", {
	className: $.title,
	"data-testid": "article-title",
	children: e
}), nt = () => {
	let { articleId: e, collectionId: t } = te(), { selectedLanguageId: n } = o(), { data: r, loading: i, error: a } = c({
		selectedLanguageId: n,
		fetchPolicy: "cache-only"
	});
	if (!t || !e) throw Error("CollectionId and ArticleId are required to display Internal Knowledge Base Article");
	if (i || !r) return /* @__PURE__ */ T(d, {});
	if (a) throw a;
	return /* @__PURE__ */ T(rt, {
		collectionId: t,
		articleId: e,
		languageId: r.selectedLanguage.languageId
	});
}, rt = ({ collectionId: e, articleId: n, languageId: r }) => {
	let i = re(), { loading: a, data: o, error: s } = t({
		variables: {
			collectionId: e,
			articleId: n,
			languageId: r
		},
		onCompleted: () => i({
			articleId: n,
			languageId: r,
			origin: { internalKb: { id: e } }
		})
	}), { openToArticle: c } = l(), { urlSearch: f } = u();
	if (b(() => {
		o && !f && c(n);
	}, [
		n,
		c,
		o,
		f
	]), s) {
		if (s.graphQLErrors.find((e) => e.extensions?.code === "NOT_FOUND")) return /* @__PURE__ */ T(j, {
			className: V.notFound,
			title: "Article not found",
			description: "The article you are looking for does not exist"
		});
		throw s;
	}
	if (a || !o?.knowledgeBaseArticle?.article) return /* @__PURE__ */ T(M, {
		className: z(V.content, V.loadingContent),
		children: /* @__PURE__ */ T(d, {})
	});
	let p = o.knowledgeBaseArticle.article;
	return /* @__PURE__ */ T(et, {
		collectionId: e,
		languageId: r,
		article: p
	});
};
export { nt as default };

//# sourceMappingURL=article-ClhV4-oH.js.map